import AutomaticCapacitorBanks from "../classes/AutomaticCapacitorBank"

export const automaticCapacitorBanks = [
  new AutomaticCapacitorBanks({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new AutomaticCapacitorBanks({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new AutomaticCapacitorBanks({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
